<div class="val-panneau-information">
  <i class="val-panneau-information-icone fas fa-info-circle"></i>
  <div class="val-panneau-information-corps">
    @if (titre)
    {
      <div class="val-panneau-information-titre">{{ titre }}</div>
    }
    <div class="val-panneau-information-contenu">
      <ng-content></ng-content>
    </div>
  </div>
</div>
